export const Titles = {
  male: ['Mr', 'Master'],
  female: ['Mrs', 'Ms', 'Miss']
}



// WEBPACK FOOTER //
// ./src/data/Titles.js